import { render, staticRenderFns } from "./ExamesForm.vue?vue&type=template&id=b9d5a7d2"
import script from "./ExamesForm.vue?vue&type=script&lang=js"
export * from "./ExamesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports